module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('em', [_vm._v("Figures")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('p', {
    staticClass: "list-fig"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/013_Introduction#fig_I.1"
    }
  }, [_vm._v("I.1 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Roman coin depicting the consecration of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Divus")]), _vm._v(" Augustus’s temple in Rome")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Introduction#fig_I.2"
    }
  }, [_vm._v("I.2 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Roman coin depicting the cultic image of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Divus")]), _vm._v(" Augustus in his temple in Rome")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter01#fig_1.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1.1 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Temple of Dendur (Egypt)")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter01#fig_1.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1.2 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Relief of Augustus depicted as a pharaoh from the temple of Dendur")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter01#fig_1.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1.3 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Cartouche from the temple of Dendur calling Augustus “pharaoh”")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter01#fig_1.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1.4 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Cartouche from the temple of Dendur hailing Augustus as “Caesar victorious general”")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter01#fig_1.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1.5 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Pergamene coin depicting the temple of Roma and Augustus in Pergamum")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter02#fig_2.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.1 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Site map of Roman Philippi")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter02#fig_2.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.2 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Philippian coin depicting the founding of the colony")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter02#fig_2.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.3 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Philippian coin depicting the monument of Augustus and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Divus")]), _vm._v(" Julius")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter02#fig_2.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.4 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Philippian coin depicting the monument of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Divus")]), _vm._v(" Augustus and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Divus")]), _vm._v(" Julius")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter02#fig_2.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.5 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Remains of the monument of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sacerdotes")]), _vm._v(" of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Diva")]), _vm._v(" Augusta in Philippi")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter02#fig_2.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.6 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Reconstruction of the monument of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sacerdotes")]), _vm._v(" of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Diva")]), _vm._v(" Augusta in Philippi")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter02#fig_2.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.7 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Site map of the lower terrace of Philippi’s forum")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter02#fig_2.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.8 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Papyrus leaf from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Feriale Duranum")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter02#fig_2.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.9 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Philippian coin depicting the goddess Victory and Roman military standards")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter03#fig_3.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.1 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Site map of Thessalonica")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter03#fig_3.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.2 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Drawing of the Golden Gate of ancient Thessalonica")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/016_Chapter03#fig_3.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.3 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Thessalonian coin depicting the goddesses Freedom and Victory")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter03#fig_3.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.4 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Thessalonian coin depicting the bust of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("theos")]), _vm._v(" Julius Caesar")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter03#fig_3.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.5 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Drawing of inscription attesting to the temple of Caesar Augustus")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter03#fig_3.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.6 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Statue of Octavian Augustus")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter03#fig_3.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.7 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Thessalonian coin picturing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("theos")]), _vm._v(" Augustus")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter03#fig_3.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.8 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Thessalonian coin depicting "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("thea")]), _vm._v(" Livia")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter03#fig_3.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.9 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Statue thought to represent the emperor Claudius")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter03#fig_3.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.10 "), _c('span', {
    staticClass: "pad-f1"
  }, [_vm._v("Cuirassed statue, possibly of Octavian Augustus")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter04#fig_4.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.1 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Site map of second-century AD Corinth")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter04#fig_4.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.2 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Marble block base from Corinth’s theater that may have held an image of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Divus")]), _vm._v(" Julius Caesar")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter04#fig_4.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.3 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Marble statue, probably of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Divus")]), _vm._v(" Julius, from Corinth’s Julian Basilica")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter04#fig_4.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.4 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Marble statue of Gaius Caesar from Corinth’s Julian Basilica")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter04#fig_4.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.5 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Marble statue of Lucius Caesar from Corinth’s Julian Basilica")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter04#fig_4.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.6 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Statue base from Corinth’s forum that once held a bronze statue of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Divus")]), _vm._v(" Augustus")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter04#fig_4.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.7 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Reconstruction of the statue base of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Divus")]), _vm._v(" Augustus from Corinth’s forum")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter04#fig_4.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.8 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Bench from the monument of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Divus")]), _vm._v(" Augustus in the forum with its butt grooves")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter04#fig_4.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.9 "), _c('span', {
    staticClass: "pad-f"
  }, [_vm._v("Marble statue of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Divus")]), _vm._v(" Augustus from Corinth’s Julian Basilica")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter04#fig_4.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.10 "), _c('span', {
    staticClass: "pad-f1"
  }, [_vm._v("Marble statue, possibly of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Divus")]), _vm._v(" Augustus, from Corinth’s theater")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter04#fig_4.11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.11 "), _c('span', {
    staticClass: "pad-f1"
  }, [_vm._v("Corinthian coin possibly depicting Nero’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("genius")]), _vm._v(" in a Corinthian temple")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter04#fig_4.12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.12 "), _c('span', {
    staticClass: "pad-f1"
  }, [_vm._v("Corinthian coin depicting Corinth’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("genius")])])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter04#fig_4.13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.13 "), _c('span', {
    staticClass: "pad-f1"
  }, [_vm._v("Corinthian coin depicting Corinth’s Julian Family Temple")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter04#fig_4.14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.14 "), _c('span', {
    staticClass: "pad-f1"
  }, [_vm._v("Corinthian coin depicting an enthroned female figure that some connect with the Julian Family Temple")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter04#fig_4.15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.15 "), _c('span', {
    staticClass: "pad-f1"
  }, [_vm._v("Remains of Corinth’s Julian Basilica")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter04#fig_4.16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.16 "), _c('span', {
    staticClass: "pad-f1"
  }, [_vm._v("Reconstruction of Corinth’s Julian Basilica in the first century AD")])])]), _vm._v(" "), _c('p', {
    staticClass: "list-fig"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter04#fig_4.17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.17 "), _c('span', {
    staticClass: "pad-f1"
  }, [_vm._v("Remains of Archaic Temple")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3cf1cbe4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Figures.vue
// module id = 72
// module chunks = 0